import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'

import { getEmptyStateContent } from 'modules/job_catalog/lib/nodesUtils'
import { CategoryType } from 'modules/job_catalog/lib/nodesUtils'

interface Props {
  category: CategoryType
}

const EmptyState = ({ category }: Props) => {
  const { title, description, icon } = getEmptyStateContent(category)
  return (
    <Box
      height="full"
      overflowY="hidden"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap="s12"
    >
      <F0Button
        hideLabel
        icon={icon}
        label="Outline"
        onClick={function Xs() {}}
        round
        size="lg"
        variant="outline"
      />
      <Text.Header2 weight="semibold" color="grey1000">
        {title}
      </Text.Header2>
      <Text.Normal weight="normal" color="grey600">
        {description}
      </Text.Normal>
    </Box>
  )
}

export default EmptyState
